import './components/_burger';
import './components/_slider';
import './components/_tabs';
